import type { Client, Phase } from '../../types/domain';

// Clé Jira effective d'une phase : celle de la phase si renseignée, sinon celle du client (réglée une
// fois pour toutes plutôt que ressaisie à chaque phase/conversion). Ne jamais utiliser pour pré-remplir
// un formulaire d'édition (phase.jira_project_key doit y rester la valeur brute, propre à la phase) —
// uniquement pour la lecture (bouton Import, agrégation des heures, synchro).
export function effJiraKey(
  phase: Pick<Phase, 'jira_project_key'> | null | undefined,
  client: Pick<Client, 'jira_project_key'> | null | undefined,
): string {
  return phase?.jira_project_key || client?.jira_project_key || '';
}

// Clés projet Jira distinctes de toutes les phases de tous les clients.
export function jiraProjectKeys(clients: Client[] | null | undefined): string[] {
  const keys = (clients || []).flatMap((c) =>
    (c.phases || []).map((ph) => effJiraKey(ph, c)).filter(Boolean),
  );
  return [...new Set(keys)];
}

// Clé Jira d'une phase créée à la conversion d'une affaire : la sienne si saisie, sinon la clé
// globale (pré-remplie avec celle du client). Vide si aucune des deux : la conversion l'alerte.
export function draftJiraKey(
  phaseKey: string | null | undefined,
  globalKey: string | null | undefined,
): string {
  return (phaseKey || '').trim().toUpperCase() || (globalKey || '').trim().toUpperCase();
}
